/* QUIETUDE - fly to cart.

   The product leaves its photo as a white medallion, arcs up and drops into
   the cart button in the header; the count pops as it lands. When the header
   has scrolled away, a glass cart appears top right just long enough to catch
   it.

   Owns nothing else. quietude-pdp.js and quietude-rail.js still do the adds,
   quietude-drawer.js still owns the drawer - this file only listens, animates,
   and holds the drawer back until the product has landed, by wrapping
   window.qtOpenCart.

   Two ways in, because the shop has two: the product page submits a form, the
   home cards fire a click on [data-quick-add]. Both are read the same way -
   animate only once the handler has called preventDefault, which is the signal
   the add is going through fetch. A plain POST reloads the page, and there is
   nothing to animate through a reload. */
(function () {
  if (window.__qtFlyBound) return;
  window.__qtFlyBound = true;

  var DUR = 640;    /* flight, ms */
  var TRAIL = 70;   /* the blurred echo lags this far behind */
  var STEPS = 44;   /* bezier samples baked into the keyframes */
  var LAND = 26;    /* diameter the medallion ends at, px */

  function reduced() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function centre(r) { return { x: r.left + r.width / 2, y: r.top + r.height / 2 }; }
  function viewH() { return document.documentElement.clientHeight || window.innerHeight || 0; }
  function onScreen(r) { return r.width > 0 && r.bottom > 4 && r.top < viewH() - 4; }

  /* -- where the product takes off from -- */
  var HOLDERS = '.hy-card,.qt-card,.acc-card,.hp-card,.mm-card,.card,.mm-pdp,.mm-main,article';
  var PICKS = [
    '.mm-gallery [data-slide].on img',
    '.mm-gallery [data-slide] img',
    '.hy-card-img',
    '.mm-media img',
    '.acc-media img',
    '.hp-card-media img',
    '.card-media img',
    'img'
  ];

  /* A hy-card stacks two photos and cross-fades them on hover, so the one to
     throw is whichever is actually showing under the cursor - not the first in
     the DOM. */
  function mostVisible(list) {
    var best = null, bestOp = -1;
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (!onScreen(el.getBoundingClientRect())) continue;
      var op = parseFloat(window.getComputedStyle(el).opacity);
      if (isNaN(op)) op = 1;
      if (op > bestOp) { bestOp = op; best = el; }
    }
    return bestOp > 0.05 ? best : null;
  }

  function source(el) {
    var holder = el.closest(HOLDERS) || document.querySelector('.mm-pdp') || document;
    for (var i = 0; i < PICKS.length; i++) {
      var img = mostVisible(holder.querySelectorAll(PICKS[i]));
      if (img) return { rect: img.getBoundingClientRect(), src: img.currentSrc || img.src };
    }
    var anchor = el.tagName === 'FORM'
      ? el.querySelector('.mm-cta, button[type="submit"], [type="submit"]')
      : el;
    var br = anchor && anchor.getBoundingClientRect();
    return br && onScreen(br) ? { rect: br, src: '' } : null;
  }

  /* -- where it lands: the header cart, or a glass stand-in -- */
  var ghostEl = null, ghostHide = 0;

  function count() {
    var c = document.querySelector('.mm-count, .cart-count, .hy-count');
    return c ? c.textContent.trim() : '0';
  }

  function ghost() {
    if (!ghostEl) {
      ghostEl = document.createElement('div');
      ghostEl.className = 'qt-fly-ghost';
      ghostEl.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M5 7h14l-1.2 13H6.2z"/><path d="M9 7V5a3 3 0 0 1 6 0v2"/></svg>' +
        '<span class="qt-fly-ghost-count">' + count() + '</span>';
      document.body.appendChild(ghostEl);
    }
    ghostEl.querySelector('.qt-fly-ghost-count').textContent = count();
    clearTimeout(ghostHide);
    void ghostEl.offsetWidth;          /* reflow, so the transition actually runs */
    ghostEl.classList.add('on');
    return ghostEl;
  }

  function target() {
    var btn = document.querySelector('.cart-btn, [data-cart-open]');
    if (btn) {
      var r = btn.getBoundingClientRect();
      if (r.width > 0 && r.top >= 2 && r.bottom <= viewH() - 2) return btn;
    }
    return ghost();
  }

  /* -- the medallion -- */
  function clone(src, rect, trail) {
    var el = document.createElement('div');
    el.className = 'qt-fly' + (trail ? ' is-trail' : '');
    el.innerHTML = src ? '<img src="' + src + '" alt="">' : '<i class="qt-fly-empty"></i>';
    var size = Math.min(Math.max(rect.width, rect.height, 96), 260);
    el.style.width = size + 'px';
    el.style.height = size + 'px';
    el.style.left = (rect.left + rect.width / 2 - size / 2) + 'px';
    el.style.top = (rect.top + rect.height / 2 - size / 2) + 'px';
    document.body.appendChild(el);
    return { el: el, size: size };
  }

  /* -- arc: quadratic bezier, eased in JS so the path stays even -- */
  function frames(from, to, size, dim) {
    var p0 = centre(from), p1 = centre(to);
    var span = Math.hypot(p1.x - p0.x, p1.y - p0.y);
    var lift = Math.min(Math.max(70, span * 0.22), 210);
    var cx = p0.x + (p1.x - p0.x) * 0.38;
    /* the crest of a quadratic sits near (p0+p1)/4 + c/2, so clamp the control
       point instead of the curve: the product never leaves the screen */
    var crest = 2 * 92 - (p0.y + p1.y) / 2;
    var cy = Math.max(crest, Math.min(p0.y, p1.y) - lift);
    var end = LAND / size;
    var out = [];

    for (var i = 0; i <= STEPS; i++) {
      var t = i / STEPS;
      var e = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      var u = 1 - e;
      var x = u * u * p0.x + 2 * u * e * cx + e * e * p1.x - p0.x;
      var y = u * u * p0.y + 2 * u * e * cy + e * e * p1.y - p0.y;
      var pluck = 1 + 0.14 * Math.pow(1 - Math.min(t / 0.2, 1), 2);
      var s = (1 - e + e * end) * pluck;
      var fade = t < 0.1 ? 0.55 + t / 0.1 * 0.45
               : t < 0.74 ? 1
               : 1 - (t - 0.74) / 0.26 * 0.92;
      out.push({
        offset: t,
        transform: 'translate(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px) scale(' +
                   s.toFixed(4) + ') rotate(' + (-9 * Math.sin(Math.PI * t)).toFixed(2) + 'deg)',
        borderRadius: (16 + 34 * e).toFixed(1) + '%',
        opacity: (fade * dim).toFixed(3)
      });
    }
    return out;
  }

  /* -- landing beat on whatever caught it -- */
  function land(el) {
    var badge = el.querySelector('.mm-count, .cart-count, .hy-count, .qt-fly-ghost-count');
    el.classList.remove('is-catching');
    if (badge) badge.classList.remove('is-bump');
    void el.offsetWidth;
    el.classList.add('is-catching');
    if (badge) badge.classList.add('is-bump');
    setTimeout(function () {
      el.classList.remove('is-catching');
      if (badge) badge.classList.remove('is-bump');
    }, 800);
  }

  function fly(el) {
    if (reduced() || typeof document.body.animate !== 'function') return null;
    var from = source(el);
    if (!from) return null;
    var to = target();
    var toRect = to.getBoundingClientRect();

    var main = clone(from.src, from.rect, false);
    var echo = clone(from.src, from.rect, true);
    var anim = main.el.animate(frames(from.rect, toRect, main.size, 1),
                               { duration: DUR, easing: 'linear', fill: 'forwards' });
    var echoA = echo.el.animate(frames(from.rect, toRect, echo.size, 0.34),
                                { duration: DUR, delay: TRAIL, easing: 'linear', fill: 'forwards' });
    echoA.onfinish = function () { echo.el.remove(); };

    return new Promise(function (done) {
      var settled = false;
      function finish() {
        if (settled) return;
        settled = true;
        main.el.remove();
        echo.el.remove();
        land(to);
        if (to === ghostEl) {
          ghostEl.querySelector('.qt-fly-ghost-count').textContent = count();
          ghostHide = setTimeout(function () { ghostEl.classList.remove('on'); }, 1200);
        }
        done();
      }
      anim.onfinish = finish;
      setTimeout(finish, DUR + 140);   /* safety net if the tab was backgrounded */
    });
  }

  /* -- hold the drawer until the product has landed --
     Defined as an accessor so load order does not matter: quietude-drawer.js
     assigns the real opener whenever it runs, and its callers still see a
     function on window.qtOpenCart. */
  var pending = null;
  var realOpen = null;

  function opener(cart) {
    var open = function () { if (typeof realOpen === 'function') realOpen(cart); };
    if (pending) pending.then(open, open);
    else open();
  }

  if (typeof window.qtOpenCart === 'function') realOpen = window.qtOpenCart;
  try {
    Object.defineProperty(window, 'qtOpenCart', {
      configurable: true,
      get: function () { return opener; },
      set: function (fn) { realOpen = fn; }
    });
  } catch (e) { window.qtOpenCart = opener; }

  function launch(el) {
    var flight = fly(el);
    if (!flight) return;
    pending = flight;
    flight.then(function () { pending = null; }, function () { pending = null; });
  }

  /* -- triggers --
     Both listen on the document in the bubble phase, so the page's own handler
     has already run: defaultPrevented means the add is going through fetch and
     the page is staying put. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!e.defaultPrevented) return;          /* plain POST: the page is about to reload */
    launch(form);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-quick-add]');
    if (!btn || !btn.getAttribute('data-quick-add')) return;
    if (!e.defaultPrevented) return;          /* the rail did not take the click */
    launch(btn);
  });
})();
